export interface SubtaskType {
  label: string;
  type: string;
}

export const SUBTASK_TYPES: SubtaskType[] = [
  { label: "Coding Challenges", type: "coding" },
  { label: "Video", type: "video" },
  { label: "Notes", type: "notes" },
  { label: "Interactive Notebook", type: "notebook" },
  { label: "MCQ", type: "mcq" },
  { label: "Project Coding", type: "project_coding" }
];

export const SUBTASK_TYPES_WITH_LEVEL: SubtaskTypes[] = ["video", "notes"];

export type SubtaskTypes =
  | "video"
  | "notes"
  | "notebook"
  | "mcq"
  | "coding"
  | "project_coding";

export const CODING_EDITOR_TYPES: SubtaskType[] = [
  { label: "Python Editor", type: "python_coding" },
  { label: "SQL Editor", type: "sql_coding" },
  { label: "Frontend Editor", type: "frontend_coding" }
];